module.exports = __webpack_public_path__ + "static/media/logo.364c9b87.png";